module.exports = __webpack_public_path__ + "static/media/TMDBlogo.08392f18.svg";